export default "__VITE_ASSET__WgA8U83l__"